import { createSlice } from '@reduxjs/toolkit';

import { getStatisticsThunk } from './statistics.thunks';

const initialState = {
  statistics: {
    policies: 0,
    agencies: 0,
    peoples: 0,
    priorities: 0,
    divisions: 0,
  },
};

const statisticsSlice = createSlice({
  name: 'statistics',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getStatisticsThunk.fulfilled, (state, action) => {
      state.statistics = { ...state.statistics, ...action.payload };
    });
  },
});

export const statisticsReducer = statisticsSlice.reducer;
